import React, { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import useChapterActionIdMatch from "../../../hooks/useChapterActionIdMatch";

import SearchBlockRHF from "../../../components/GeneralComponents/searchBlockRHF/SearchBlockRHF";
import ToolBlock from "../../../components/AdministrativeProcedures/commonComponents/ToolBlock/ToolBlock";
import TableComponent from "../../../components/GeneralComponents/SearchTable/tableComponent";

import { CERTIFICATES_COLUMNS } from "../../../components/GeneralComponents/SearchTable/TablesColumns";

import { getDataCertificatesBySearchParams } from "../../../redux/actions";

import { options } from "../../../components/GeneralComponents/searchBlockRHF/optionsSearchBlockRHF";

import styles from "./CertificatesContainer.module.css";
import {
  setPageIndexLicenses,
  setSearchParamsLicenses,
} from "../../../redux/certificateReducer/actionsCertificate";

export default function Certificates() {
  const dispatch = useDispatch();

  const [selectedRowData, setSelectedRowData] = useState(null);
  const [selectedPage, setSelectedPage] = useState(0);
  const [searchParams, setSearchParams] = useState({
    name: "",
    surname: "",
    midname: "",
    birthDate: "",
    licenseNum: "",
    persNum: "",
    cardStatusCode: 1,
    licenseType: 0,
  });

  const sortedMenuNames = useSelector((state) => {
    const { roleControllerReducer } = state;
    return roleControllerReducer.sortedMenuNames;
  });
  const dataFromStateCer = useSelector((state) => {
    const { certificateReducer } = state;
    return certificateReducer.data;
  });
  const searchParamsFromState = useSelector((state) => {
    const { certificateReducer } = state;
    return certificateReducer.searchParams;
  });
  const pageIndexFromState = useSelector((state) => {
    const { certificateReducer } = state;
    return certificateReducer.pageIndex;
  });

  const viewAccess = useChapterActionIdMatch(sortedMenuNames?.CERTIFICATES?.viewRkId?.chapterActionId);
  const editAccess = useChapterActionIdMatch(sortedMenuNames?.CERTIFICATES?.editRkId?.chapterActionId);

  const handleClear = () => {
    setSelectedPage(0);
    setSelectedRowData(null);
    setSearchParams(
      structuredClone({
        name: "",
        surname: "",
        midname: "",
        birthDate: "",
        licenseNum: "",
        persNum: "",
        cardStatusCode: 1,
        licenseType: 0,
      }),
    );
    dispatch(
      getDataCertificatesBySearchParams(
        {
          name: "",
          surname: "",
          midname: "",
          birthDate: "",
          licenseNum: "",
          persNum: "",
          cardStatusCode: 1,
          licenseType: 0,
        },
        0,
      ),
    );
    dispatch(
      setSearchParamsLicenses({
        name: "",
        surname: "",
        midname: "",
        birthDate: "",
        licenseNum: "",
        persNum: "",
        cardStatusCode: 1,
        licenseType: 0,
      }),
    );
    dispatch(setPageIndexLicenses(0));
  };

  const handleChange = (e) => {
    if (e.target) {
      setSearchParams({
        ...searchParams,
        [e.target.dataset.id]: e.target.value,
      });
    } else {
      setSearchParams({ ...searchParams, [e.key]: e.value });
    }
  };

  const handleSearch = () => {
    setSelectedPage(0);
    setSelectedRowData(null);
    dispatch(getDataCertificatesBySearchParams(searchParams, 0));
    dispatch(setSearchParamsLicenses({ ...searchParams }));
    dispatch(setPageIndexLicenses(0));
  };

  const handleRowSelect = (rowData) => {
    setSelectedRowData(rowData);
  };

  const fetchPageData = (pageIndex) => {
    setSelectedPage(pageIndex);
    dispatch(setPageIndexLicenses(pageIndex));
  };
  useMemo(() => {
    setSearchParams({ ...searchParamsFromState });
    setSelectedPage(pageIndexFromState);
  }, []);

  useEffect(() => {
    setSelectedRowData(null);
    dispatch(getDataCertificatesBySearchParams(searchParams, selectedPage));
  }, [selectedPage]);

  return (
    <div className={styles["content-container"]}>
      <SearchBlockRHF
        options={options.inputsCertificates}
        handleChange={handleChange}
        handleSearch={handleSearch}
        handleClear={handleClear}
        searchParams={searchParams}
        externalStyles={styles}
      />
      <ToolBlock
        id={selectedRowData?.id}
        appStatusId={selectedRowData?.cardStatusCode}
        editAccess={editAccess}
        viewAccess={viewAccess}
      />
      <TableComponent
        fetchData={fetchPageData}
        onRowSelect={handleRowSelect}
        columns={CERTIFICATES_COLUMNS}
        data={dataFromStateCer.content || []}
        totalPages={dataFromStateCer.totalPages || 0}
        totalElements={dataFromStateCer.totalElements || 0}
        selectedPage={selectedPage}
      />
    </div>
  );
}
